export const USER_ROLES = {
    ADMIN: 'ROLE_ADMIN',
    SEKOLAH: 'ROLE_SEKOLAH',
    SISWA: 'ROLE_USER'
}